/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import { messages } from './messages';

const styles = xcss({
	paddingBlock: 'space.500',
	paddingInline: 'space.300',
});

export function LoadingState() {
	const { formatMessage } = useIntl();
	const items = Array.from({ length: 5 }, (_, index) => (
		<Skeleton
			isShimmering
			width="100%"
			height={token('space.200')}
			testId="skeleton-shimmering"
			key={index}
		/>
	));

	return (
		<Box xcss={styles} testId="global-invite--loading-state">
			<VisuallyHidden>{formatMessage(messages.loadingLabel)}</VisuallyHidden>
			<Stack space="space.100" testId="skeleton-group">
				{items}
			</Stack>
		</Box>
	);
}
